import { defineRouting } from 'next-intl/routing';

const locales = ['de', 'en', 'nl'];

export const routing = defineRouting({
  locales,
  defaultLocale: 'de',
  alternateLinks: false,
  localePrefix: 'always',
});
